<loading-spinner>
  <div class="loading-spinner-container text-center my-5">
    <div class="spinner-border text-primary" role="status" style={ props.size ? `width: ${props.size}; height: ${props.size}` : '' }>
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-3 text-muted" if={ props.message }>{ props.message }</p>
  </div>

  <style>
    .loading-spinner-container {
      padding: 2rem 0;
    }

    .loading-spinner-container .spinner-border {
      width: 3rem;
      height: 3rem;
    }

    .loading-spinner-container p {
      font-size: 0.95rem;
    }
  </style>
</loading-spinner>
